// URLs in format: http://localhost:8090/starfish-dev/instructor/serviceCatalog.html#/service/1111
// Returns { section: "serviceCatalog", hash: "/service/1111" }
import { getWord } from "./tenant";

export const parseURL = URL => {
  // For some reason window.location.href is undefined in IE11
  // Check https://stackoverflow.com/questions/47715305/window-location-href-undefined-ie11jquerytime?rq=1
  // Adding this trick will prevent href to be undefined when this code is called
  const targetURL = URL || window.location + '';
  const urlArray = targetURL.split("#");
  const head = urlArray[0];
  const hash = urlArray[1];

  const betweenSlashes = head.split("/");
  const section = betweenSlashes[betweenSlashes.length - 1].split(".html")[0];
  return { section, hash };
};

const isServiceProfile = hash => /\/service\/\d+$/.test(hash);

const isConnectionProfile = hash => /\/connection\/\d+$/.test(hash);

const isScheduleAppointment = hash => /\/(connection|service)\/\d+\/schedule/.test(hash);

const isEditAppointment = hash => /\/appointment\/\d+$/.test(hash);

const getServiceCatalogTitle = (hash, isStudent) => {
  if ( isServiceProfile(hash) ) return "Service Profile";
  if ( isConnectionProfile(hash) ) return "Connection Profile";
  if ( isScheduleAppointment(hash) ) return "Schedule Appointment";
  return isStudent ? getWord('mySuccessNetwork') : "Services";
};

const getUpcomingTitle = hash => {
  if ( isEditAppointment(hash) ) return "Edit Appointment";
  return "Upcoming";
};

export const shouldDisplayLevelUpButton = hash => isServiceProfile(hash) || isConnectionProfile(hash) || isScheduleAppointment(hash);

export const shouldDisplayCancelButton = hash => isEditAppointment(hash);

export const getHeaderTitle = (URL, isStudent) => {
  const { section, hash } = parseURL(URL);
  switch ( section ) {
    case "serviceCatalog":
      return getServiceCatalogTitle(hash, isStudent);
    case "upcoming":
      return getUpcomingTitle(hash);
    case "waitingRoom":
      return "Waiting Room";
    case "studentIntakeForm":
      return "Intake";
    case "dashboard":
      return getWord("Starfish");
    case "request-help":
      return getWord("studentHelp");
    default:
      return "";
  }
};

export const getSectionTitle = section => {
  switch ( section ) {
    case "DASHBOARD":
      return "Dashboard";
    case "MESSAGES":
      return "Messages";
    case "REQUEST_HELP":
      return getWord('studentHelp');
    case "HISTORY":
      return "History";
    case "DEGREE_PLANNER":
      return "Degree Planner";
    case "COURSES":
      return getWord('courses');
    case "SUCCESS_PLANS":
      return "Success Plans";
    case "INVENTORY":
      return "Inventory";
    default:
      return getWord('Starfish');
  }
};
